const emailPattern = {
  pattern: {
    value: /^[\w-.]+@([\w-]+.)+[\w-]{2,4}$/,
    message: "メールアドレスの形式が正しくありません",
  },
}

const requiredCheckboxGroup = {
  validate: {
    atleastOneRequired: (value: string | string[]) =>
      (value && value.length >= 1) || "1つ以上選択してください",
  },
}

const requiredNonNegativeNumber = {
  required: "入力してください",
  min: {
    value: 0,
    message: "0以上の数値を入力してください",
  },
  valueAsNumber: true,
}

const requiredText = {
  required: "入力してください",
}

export {
  emailPattern,
  requiredCheckboxGroup,
  requiredNonNegativeNumber,
  requiredText
}

